import ReactMarkdown from 'react-markdown';

import { PageTitles } from '@revelio/core';

import { ContentWrapper } from '../../../shared/ui/content-wrapper/content-wrapper';
import DashboardPage from '../../DashboardPage';
import { TrailPageConent } from '../../deliverables/trial-pages/components/trial-page-content';
import trialPageContent from '../../deliverables/trial-pages/markdown/data-builder-trial-content.md';

export const DataBuilderTrialPage = () => {
  return (
    <DashboardPage
      title={[PageTitles.DELIVERABLES, PageTitles.DATA_BUILDER]}
      loading={false}
      scrollY={true}
    >
      <TrailPageConent>
        <ContentWrapper>
          <ReactMarkdown>{trialPageContent}</ReactMarkdown>
        </ContentWrapper>
      </TrailPageConent>
    </DashboardPage>
  );
};
